<h2 mat-dialog-title>{{ 'Tilgangsbegrensning for {type}'|translate: {type: typeNavn} }}</h2>
@switch (modus()) {
  @case ('rediger') {
    <form [formGroup]="skjema" (ngSubmit)="lagre()" novalidate>
      <mat-dialog-content class="rediger">
        <fieldset>
          <mat-form-field>
            <mat-label>{{ 'Medlemmer som ikke skal ha tilgang'|translate }}</mat-label>
            <velg-medlemmer [skjemakontroll]="skjema.controls.medlemmer" [medlemmer]="valgbareMedlemmer()" [laasteMedlemmer]="laasteMedlemmer()">
              <ng-template let-medlem>
                <medlem-listevisning-kompakt [medlem]="medlem">
                  @if(harArvetSkjerming(medlem)){
                    <span class="arvet">
                      <span class="arvet">{{ 'Arvet fra {forelder}'|translate: {forelder: typenavn().forelder} }}</span>
                    </span>
                  }
                </medlem-listevisning-kompakt>
              </ng-template>
            </velg-medlemmer>

          </mat-form-field>
          <mat-form-field>
            <mat-label>{{ "Kommentar"|translate }}</mat-label>
            <riktekst-redigering [skjemakontroll]="skjema.controls.aarsak"/>
            @if (skjema.controls.aarsak.hasError('maxlength')) {
              <mat-error data-testid="maxlength">{{ skjema.controls.aarsak.errors | standardvalideringsfeil:'maxlength' }}</mat-error>
            }
          </mat-form-field>
        </fieldset>
        @if (skjerming().medlemmerIdUtenTilgangTilForelder.length > 0) {
          <inline-melding>
          @switch (type) {
            @case (typer.sak) {
              {{ 'Merk at følgende medlemmer ikke har tilgang til overliggende møte og derfor ikke kan fjernes'|translate }}
            }
            @case (typer.saksdokument) {
              {{ 'Merk at følgende medlemmer ikke har tilgang til overliggende sak og derfor ikke kan fjernes'|translate }}
            }
            @case (typer.arkivmappe) {
              {{ 'Merk at følgende medlemmer ikke har tilgang til overliggende mappe og derfor ikke kan fjernes'|translate }}
            }
            @case (typer.arkivdokument) {
              {{ 'Merk at følgende medlemmer ikke har tilgang til overliggende mappe og derfor ikke kan fjernes'|translate }}
            }
          }
          <ul>
            @for(info of skjermedeMedlemmer();track info.medlem.id){
              @if(info.arvet){
                <li>{{info.medlem.navn}}</li>
              }
            }
          </ul>
          </inline-melding>
        }
        <skjerming-beskrivelse [type]="type"/>
        @if(valideringsfeil().length > 0){
        <inline-melding type="feil" voksHorisontalt="true">
            {{'Oppdatering av skjerming feilet med følgende:'|translate}}
            <ul>
              @for(feil of valideringsfeil(); track $index){
                <li>{{feil}}</li>
              }
            </ul>
          </inline-melding>
        }
      </mat-dialog-content>
      <mat-dialog-actions align="center">
        <button mat-button type="button" (click)="avbryt()">{{ "Avbryt" | translate }}</button>
        <submit-button [skjema]="skjema" [arbeidPaagaar]="lagrer()" [spinnerTekst]="'Lagrer...'|translate">
          {{ 'Lagre'|translate }}
        </submit-button>
      </mat-dialog-actions>
    </form>
  }

  @case ('vis') {
    <mat-dialog-content class="vis">
      <skjerming-vis [skjerming]="skjerming()" [type]="type"/>
    </mat-dialog-content>
    <mat-dialog-actions align="center">
      <button mat-button (click)="avbryt()">{{ "Lukk" | translate }}</button>
    </mat-dialog-actions>
  }

  @case ('skjermet') {
    <mat-dialog-content class="skjermet">
      <p>
        @if (skjerming().harSkjermetForelderForKallendeBruker) {
          @switch (type) {
            @case (typer.sak) {
              {{ 'Du kan ikke redigere tilgang da noen andre allerede har fjernet din tilgang til overliggende møte.'|translate }}
            }
            @case (typer.saksdokument) {
              {{ 'Du kan ikke redigere tilgang da noen andre allerede har fjernet din tilgang til overliggende sak.'|translate }}
            }
            @case (typer.arkivdokument) {
              {{ 'Du kan ikke redigere tilgang da noen andre allerede har fjernet din tilgang til overliggende mappe.'|translate }}
            }
            @case (typer.arkivmappe) {
              {{ 'Du kan ikke redigere tilgang da noen andre allerede har fjernet din tilgang til overliggende mappe.'|translate }}
            }
          }
        }
        @if (skjerming().erSkjermetForKallendeBruker) {
          {{ 'Du kan ikke redigere tilgang da noen andre allerede har fjernet din tilgang.'|translate }}
        }
        @if (skjerming().inneholderBarnSkjermetForKallendeBruker) {
          @switch (type) {
            @case (typer.moete) {
              {{ 'Du kan ikke redigere tilgang da noen andre allerede har fjernet din tilgang til saker eller dokumenter tilknyttet dette møtet.'|translate }}
            }
            @case (typer.sak) {
              {{ 'Du kan ikke redigere tilgang da noen andre allerede har fjernet din tilgang til dokumenter tilknyttet denne saken.'|translate }}
            }
            @case (typer.arkivmappe) {
              {{ 'Du kan ikke redigere tilgang da noen andre allerede har fjernet din tilgang til dokumenter eller mapper under denne biblioteksmappen.'|translate }}
            }
          }
        }
      </p>
    </mat-dialog-content>
    <mat-dialog-actions align="center">
      <button mat-button (click)="avbryt()">{{ "Lukk" | translate }}</button>
    </mat-dialog-actions>
  }
}


<!--

<md-dialog class="wm-skjerming-dialog e2e-skjerming-dialog">
  <form name="skjema" ng-submit="$ctrl.lagre(skjema)">

  <md-toolbar>
      <div class="md-toolbar-tools">
        <h2>{{$ctrl.tittel}}</h2>
        <span flex></span>
        <md-button class="md-icon-button" ng-click="$ctrl.avbryt()">
          <i class="ion-ios-close-empty"></i>
        </md-button>
      </div>
    </md-toolbar>

    <md-dialog-content>
      <div class="md-dialog-content" ng-switch="$ctrl.modus">

        <div ng-switch-when="skjermet">{{$ctrl.melding}}</div>

        <p translate>Følgende medlemmer har ikke tilgang</p>
        <wm-gruppe-vis-medlem-i-liste ng-switch-when="vis" class="e2e-medlem" medlem="medlem" ng-repeat="medlem in $ctrl.skjerming.medlemmerUtenTilgang track by medlem.id"></wm-gruppe-vis-medlem-i-liste>

        <div ng-switch-when="rediger">
            <wk-medlem-select valgte-medlemmer="$ctrl.skjemamodell.medlemmerUtenTilgang"
                              laaste-medlemmer="$ctrl.skjemamodell.medlemmerUtenTilgangTilForelder"
                              medlemmer="$ctrl.skjemamodell.tilgjengeligeMedlemmer"
                              multiple="true"
                              vis-ikon="true"
                              label="{{'Medlemmer uten tilgang' | translate}}"
                              class="e2e-deltakere"></wk-medlem-select>

            <md-input-container class="md-block md-ic-mindre-margin" flex-gt-sm>
              <label translate>Kommentar</label>
              <input ng-model="$ctrl.skjemamodell.aarsak" maxlength="255" class="e2e-aarsak">
            </md-input-container>

          <div ng-if="$ctrl.skjemamodell.medlemmerUtenTilgangTilForelder.length > 0">
            {{$ctrl.melding}}
            <ul><li ng-repeat="medlem in $ctrl.skjemamodell.medlemmerUtenTilgangTilForelder track by medlem.id">{{medlem.navn}}</li></ul>
          </div>
        </div>
      </div>
      <div ng-if="$ctrl.feilMeldinger" class="md-dialog-content valideringsfeil">
        <div ng-repeat="feil in $ctrl.feilMeldinger">
          <span>{{feil}}</span>
        </div>
      </div>
      <div ng-if="$ctrl.modus == 'vis' || $ctrl.modus == 'rediger'" class="std-margin">
        <div ng-switch="$ctrl.avhengigheter.entitetType">
          <div ng-switch-when="møte">
            <wk-tips class="inline">
              <span translate>
                Følgende informasjon er ikke synlig for medlemmer uten tilgang til møte:
                <ul>
                  <li>Formål</li>
                  <li>Saker, inkludert dokumenter og annet som er tilknyttet sakene</li>
                </ul>
                Merk at medlemmer uten tilgang til møte ikke kan settes til å signere protokoll eller avgi stemme på avstemninger.
              </span>
            </wk-tips>
          </div>

          <div ng-switch-when="sak">
            <wk-tips class="inline">
              <span translate>
                Følgende informasjon er ikke synlig for medlemmer uten tilgang til sak:
                <ul>
                  <li>Saken, inkludert dokumenter og annet som er tilknyttet denne</li>
                </ul>
                Merk at medlemmer uten tilgang til sak ikke kan settes til å signere protokoll eller avgi stemme på avstemninger.
              </span>
            </wk-tips>
          </div>

          <div ng-switch-when="arkivmappe">
            <wk-tips class="inline">
              <span translate>
                Følgende informasjon er ikke synlig for medlemmer uten tilgang til biblioteksmappe:
                <ul>
                  <li>underliggende mapper</li>
                  <li>underliggende dokumenter</li>
                </ul>
              </span>
            </wk-tips>
          </div>
        </div>
      </div>

    </md-dialog-content>

    <md-dialog-actions layout="row" layout-align="space-between center">
      <div ng-if="$ctrl.modus == 'vis'">
        <md-button ng-click="$ctrl.avbryt()"><translate>Lukk</translate></md-button>
      </div>
      <div ng-if="$ctrl.modus == 'rediger'">
        <md-button class="md-primary md-raised" type="submit" ng-disabled="skjema.$invalid"><translate>Lagre</translate></md-button>
        <md-button ng-click="$ctrl.avbrytRediger()"><translate>Avbryt</translate></md-button>
      </div>
    </md-dialog-actions>
  </form>
</md-dialog>


-->
